import s from './GuestCategoryNavigation.module.scss';
import { CallToAction } from '../../../../styled/siteBuilderModules/sharedComponents';

export default function GuestCategoryNavigation(props) {
  const { heading, categories, nameMapper } = props;

  return (
    <div className={s.wrapper}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            {heading && <h1 className={s.heading}>{heading}</h1>}
            <div className={s.body}>
              {categories.map((category) => (
                <CallToAction
                  key={category}
                  onClick={() => {
                    const elementId = nameMapper[category] ?? category;

                    window.scrollTo({
                      top: document.getElementById(elementId).offsetTop - 100,
                      behavior: 'smooth',
                    });
                  }}
                >
                  {nameMapper[category] ?? category}
                </CallToAction>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
